export default "__VITE_ASSET___9HoAHwq__"